// Re-export all schema utilities for easier imports
export * from "./schema-generators";
export * from "./product-transformer";
// NOTE: wikidata is intentionally NOT re-exported here. It uses `require("redis")`
// which depends on Node-only modules (net/tls). Re-exporting it would pull it into
// client bundles via the useItemListSchema → Grid.tsx chain.
// Import directly from "./wikidata" in server-side code (e.g. getStaticProps).
